import * as Sentry from "@sentry/capacitor";

import type { PlanToPatientApiQuery } from "@/Modules/Patients/Models/Api";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { sendPlanToPatient } from "@/Services/TherapyApi/Clients";

import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";

async function sendPlanToPatientAH(uuid: string, infoPlan: PlanToPatientApiQuery) {
  const appStore = useAppStore();

  if (!hasValue(uuid)) return undefined;

  try {
    await sendPlanToPatient(uuid, infoPlan);

    appStore.showSnackbar({
      type: NotificationType.INFO,
      message: "private_plans.maintenance_plan_has_been_sent",
    });
  } catch (err: unknown) {
    danger(err);
    Sentry.captureException(err);
  }
}

export default sendPlanToPatientAH;
